module.exports = __webpack_public_path__ + "static/media/task app.7d06a667.JPG";